export const TYPE_COLOR = {
    State: '#4cceac',
    Session: '#66b2ff',
    Decision: '#f0a500',
    Issue: '#ff6b6b',
    Note: '#a3d1ff',
};

export const IMPORTANCE_DOT = {
    High: '#ff6b6b',
    Medium: '#f0a500',
    Low: '#4cceac',
    Unknown: '#294766',
};

export const loadLayout = () => {
    try {
        const sizes = localStorage.getItem('your-focus-panels');
        if (!sizes) return [30, 70];
        return JSON.parse(sizes);
    } catch {
        return [30, 70];
    }
};

// ADDED - state display helpers
export const getStateDisplay = (val) => {
    if (val === 1) return 'Completed';
    if (val === 2) return 'Hidden';
    if (val === 999) return 'Deleted';
    return null;
};

export const getStateColor = (val) => {
    if (val === 1) return '#4cceac';
    if (val === 2) return '#6b8fa8';
    if (val === 999) return '#ff6b6b';
    return null;
};

export const getImportanceDisplay = (val) => {
    if (val === 900) return 'High';
    if (val === 500) return 'Medium';
    if (val === 100) return 'Low';
    return null;
};

export const getImportanceColor = (val) => {
    if (val === 900) return '#ff6b6b';
    if (val === 500) return '#f0a500';
    if (val === 100) return '#4cceac';
    return null;
};
